import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PopupComponent} from "../../../shared/popup/popup.component";
import {formatCurrency} from '@angular/common';
import {LoaderService} from "../../../service/loader.service";
import {SellService} from "../../../service/sell/sell.service";
import {UserRoleService} from "../../../service/userRole.service";

@Component({
    selector: 'app-popup-deposit',
    templateUrl: './popup-deposit.component.html',
    styleUrls: ['./popup-deposit.component.scss']
})
export class PopupDepositComponent implements OnInit {
    @Input() show: boolean;
    @Input() info: any;
    @Output('onClose') emitClose: EventEmitter<any> = new EventEmitter();

    popupForm: FormGroup;

    moreThenAvailablePayout = false;

    constructor(private formBuilder: FormBuilder,
                private sellService: SellService,
                private userRoleService: UserRoleService,
                private loaderService: LoaderService,
                private popupComponent: PopupComponent,) {

    }

    ngOnInit() {
        this.popupForm = this.formBuilder.group({
            amount: [null, Validators.required]
        });
    }

    onSubmit() {
        const amount = this.popupForm.controls.amount.value;
        const text = `Please confirm depositing ${formatCurrency(amount, 'en','$')}`;

        this.popupComponent.showPopupAgreement({text: text,
            confirmButtonText: 'CONFIRM<svg><rect></rect></svg>',
            cancelButtonText: '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                              '<path d="M25.5 24.1719L18.3281 17L25.5 9.82812C25.8668 9.46136 25.8668 8.86676 25.5 8.5C25.1332 8.13324 24.5386 8.13324 24.1719 8.5L17 15.6719L9.82813 8.5C9.46136 8.13324 8.86676 8.13324 8.5 8.5C8.13324 8.86676 8.13324 9.46136 8.5 9.82812L15.6719 17L8.5 24.1719C8.13324 24.5386 8.13324 25.1332 8.5 25.5C8.86676 25.8668 9.46136 25.8668 9.82813 25.5L17 18.3281L24.1719 25.5C24.5386 25.8668 25.1332 25.8668 25.5 25.5C25.8668 25.1332 25.8668 24.5386 25.5 24.1719Z" fill="#FDFD88"/>\n' +
                              '</svg>'}, (status) => {
            if (status) {
                this.submit();
            }
        });
    }

    submit() {
        const amount = this.popupForm.controls.amount.value;
        const id = this.info.id;

        this.sellService.onDeposit(id, amount).subscribe(data => {
            if(data.status){
                this.popupComponent.showPopupSuccess({text:data.message});
                this.closePopup(true);
            } else {
                this.popupComponent.showPopupError({text:data.message});
            }
        }, () => {
            this.loaderService.hideAndShowTryAgain();
        }, () => {
            this.loaderService.hide();
        });
    }

    onInputAmount() {
        if (this.info && (this.info.availableBalance !== null) && !this.isUserRoleAdmin()) {
            const activeForm = this.popupForm;
            const avaliable = typeof this.info.availableBalance === 'number' ? this.info.availableBalance : Number.parseFloat(this.info.availableBalance);
            const entered = Number.parseFloat(activeForm.controls.amount.value);

            if (avaliable < entered) {
                //activeForm.controls.amount.setValue(String(avaliable));
                this.moreThenAvailablePayout = true;
            } else {
                this.moreThenAvailablePayout = false;
            }
        }
    }

    closePopup(needUpdate = false) {
        this.emitClose.emit(needUpdate);
        this.popupForm.reset();
        this.moreThenAvailablePayout = false;
    }

    isUserRoleAdmin(): boolean {
        return this.userRoleService.isUserRoleAdmin();
    }
}
